import React from 'react'
import { Register } from '../../styles.style'
import Main from '../steps/main.component'

const Content = ({
	userLogin,
	toastError,
	toastSuccess,
	hideLoading,
	showLoading,
	providerSignupData
}) => {
	return (
		<Register>
			<Main
				userLogin={userLogin}
				toastError={toastError}
				hideLoading={hideLoading}
				showLoading={showLoading}
				toastSuccess={toastSuccess}
				providerSignupData={providerSignupData}
			/>
		</Register>
	)
}

export default Content
